import React from 'react';

const LeadEditForm = ({
  formData,
  errors,
  handleChange
}) => {

  return (
    <div className="admin__modal-column">
      <div className="form-group">
        <input
          type="text"
          name="full_name"
          value={formData.full_name}
          onChange={handleChange}
          placeholder="Full Name*"
          className={errors.full_name ? 'error' : ''}
        />
        <div className="error-message-container">
          <p className="error-message">{errors.full_name}</p>
        </div>
      </div>
      <div className="form-group">
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email*"
          className={errors.email ? 'error' : ''}
        />
        <div className="error-message-container">
          <p className="error-message">{errors.email}</p>
        </div>
      </div>
      <div className="form-group">
        <select
          name="service"
          value={formData.service || ''}
          onChange={handleChange}
          className={errors.service ? 'error' : ''}
          key={formData.service || 'empty'}
        >
          <option value="">Select a Service (optional)</option>
          <option value="video_production">Video Production</option>
          <option value="photography">Photography</option>
          <option value="editing">Video Editing</option>
          <option value="motion_graphics">Motion Graphics</option>
          <option value="drone_services">Drone Services</option>
          <option value="live_streaming">Live Streaming</option>
          <option value="consultation">Consultation</option>
          <option value="other">Other</option>
        </select>
        {formData.service && (
          <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
            Servicio: {formData.service.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
          </div>
        )}
        <div className="error-message-container">
          <p className="error-message">{errors.service}</p>
        </div>
      </div>
      <div className="form-group">
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Message"
          className={errors.message ? 'error' : ''}
          rows="4"
        />
        <div className="error-message-container">
          <p className="error-message">{errors.message}</p>
        </div>
      </div>

    </div>
  );
};

export default LeadEditForm;




